// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "d0deef33" : chunkId) + "." + {"328":"58be30220574cbe3","761":"4e8070dbb5b25eac"}[chunkId] + ".js";
};